import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let NetworkDistributorMixin = class NetworkDistributorMixin extends Vue {
    get isNetworkDistributor() {
        return this.$store.state.session.loginType === 'network_distributor';
    }
};
NetworkDistributorMixin = __decorate([
    Component
], NetworkDistributorMixin);
export default NetworkDistributorMixin;
